import { ActionIcon } from '@mantine/core'
import { Reorder, useDragControls, useReducedMotion } from 'motion/react'
import { IconGripVertical } from '@tabler/icons-react'

function ViewRow({ view, move }) {
    const controls = useDragControls()
    const reducedMotion = useReducedMotion()
    return (
        <Reorder.Item value={view} dragListener={false} dragControls={controls}
            transition={reducedMotion ? { duration: 0 } : undefined}
            className="relative flex items-center gap-2 rounded-md bg-white px-2 py-1"
            whileDrag={{ zIndex: 1, boxShadow: '0 2px 8px #0000001a' }}>
            <ActionIcon type="button" size={35} variant="subtle" color="gray" className="shrink-0 touch-none cursor-grab"
                aria-label={`Déplacer ${view.name}`} title="Glisser ou utiliser les flèches haut et bas"
                onPointerDown={(event) => controls.start(event)}
                onKeyDown={(event) => {
                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                        event.preventDefault()
                        move(view.id, event.key === 'ArrowUp' ? -1 : 1)
                    }
                }}>
                <IconGripVertical size={17} />
            </ActionIcon>
            <span className="min-w-0 truncate text-sm" title={view.name}>{view.name}</span>
        </Reorder.Item>
    )
}

export default function TableViewOrder({ views, onChange, isAdmin }) {
    const updateGroup = (visibility, next) => onChange(visibility === 'shared'
        ? [...next, ...views.filter((view) => view.visibility === 'personal')]
        : [...views.filter((view) => view.visibility === 'shared'), ...next])
    return <div>
        {['shared', 'personal'].map((visibility) => {
            const group = views.filter((view) => view.visibility === visibility)
            if (!group.length) return null
            const editable = visibility === 'personal' || isAdmin
            const move = (id, offset) => {
                const index = group.findIndex((view) => view.id === id)
                const target = index + offset
                if (target < 0 || target >= group.length) return
                const next = [...group]
                next.splice(target, 0, next.splice(index, 1)[0])
                updateGroup(visibility, next)
            }
            return <div key={visibility} className="mb-3">
                <p className="px-2 py-2 text-xs text-gray-500">{visibility === 'shared' ? 'Équipe' : 'Moi uniquement'}</p>
                {editable ? <Reorder.Group axis="y" values={group} onReorder={(next) => updateGroup(visibility, next)}>
                    {group.map((view) => <ViewRow key={view.id} view={view} move={move} />)}
                </Reorder.Group> : <>
                    {group.map((view) => <p key={view.id} className="truncate px-3 py-2 text-sm text-gray-500" title={view.name}>{view.name}</p>)}
                    <p className="px-3 text-xs text-gray-500">Ordre géré par les administrateurs.</p>
                </>}
            </div>
        })}
    </div>
}
